var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"fas fa-bell icon-label",class:{
		'text-danger': _vm.restoreCount > 0,
		'text-muted': _vm.restoreCount === 0
	},attrs:{"title":'Awaiting ' + _vm.restoreCount + ' restores',"data-cy":("restore-icon-" + (_vm.currentEvent.regionalEventID))}})}
var staticRenderFns = []

export { render, staticRenderFns }